var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPullCord01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.75,
    y: 1.36,
    className: "st2",
    width: 0.5,
    height: 10.41
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 8,
    cy: 13.13,
    r: 1.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8,14.73c-0.88,0-1.6-0.72-1.6-1.6s0.72-1.6,1.6-1.6c0.88,0,1.6,0.72,1.6,1.6S8.88,14.73,8,14.73z M8,12.04 c-0.6,0-1.1,0.49-1.1,1.1s0.49,1.1,1.1,1.1s1.1-0.49,1.1-1.1S8.6,12.04,8,12.04z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPullCord01);
export default __webpack_public_path__ + "static/media/PullCord-01.d5643aa0705e35d958ed9d1c711021aa.svg";
export { ForwardRef as ReactComponent };